import React from 'react';

export const NUMERIC_FIELDS = [
  'totalTasks',
  'dataCleaningCount',
  'caseReviewCount',
  'settledCount',
  'completedCount',
];

/**
 * TotalsRow Component
 * Builds and renders the pinned totals row for county or municipality views
 * 
 * @param {Array} rows - Array of row data to calculate totals from
 * @param {string} viewMode - Current view mode ('county' or 'municipality')
 * @param {Function} calculateStatus - Function to calculate status from completed/total counts
 * @returns {Object|null} - Totals row object for DataGrid pinnedRows prop, or null if no rows
 */
const buildTotalsRow = (rows, viewMode, calculateStatus, groupingType = 'County') => {
  if (!rows || rows.length === 0) return null;

  const initialTotals = Object.fromEntries(NUMERIC_FIELDS.map((f) => [f, 0]));

  const totals = rows.reduce((acc, row) => {
    NUMERIC_FIELDS.forEach((key) => {
      acc[key] += Number(row[key]) || 0;
    });
    return acc;
  }, initialTotals);

  const status = calculateStatus(totals.completedCount, totals.totalTasks);

  if (viewMode === 'municipality' || groupingType === 'Municipality') {
    return {
      id: 'totals',
      muniCode: 'TOTALS',
      municipality: 'TOTALS',
      ...totals,
      status,
    };
  }

  if (groupingType === 'User') {
    return {
      id: 'totals',
      userId: '',
      userName: 'TOTALS',
      ...totals,
      status,
    };
  }

  return {
    id: 'totals',
    county: 'TOTALS',
    countyCode: '',
    ...totals,
    status,
  };
};

export default buildTotalsRow;

